const breakpoints = {
  values: {
    xs: 320,
    sm: 800,
    md: 1000,
    lg: 1200,
    xl: 1600,
  },
}

export default breakpoints
